import { Component, OnInit } from '@angular/core';
import { LocationService } from '../../shared/location.service';
import { AngularFirestore } from '@angular/fire/firestore';
import { ToastrService } from 'ngx-toastr';
import { Location } from '../../shared/location.model';

@Component({
  selector: 'app-location-list',
  templateUrl: './location-list.component.html',
  styleUrls: ['./location-list.component.css']
})
export class LocationListComponent implements OnInit {

  location: Location[];
  constructor(
    private service:LocationService,
    private firestore:AngularFirestore,
    private toastr : ToastrService) { }

  ngOnInit() {
    this.service.getLocation().subscribe(actionArray =>{
      this.location = actionArray.map(item => {
        const data = item.payload.doc.data() as Location;
        const id = item.payload.doc.id;
        return { id, ...data };
      })
    });
  }
  onEdit(loc:Location){
    this.service.locationData = Object.assign({},loc);
  }

  onDelete(id: string){
    if(confirm("Are you sure to delete this Location?")){
      this.firestore.doc('location/' +id).delete();
      this.toastr.warning('Deleted Successfuly','Location');
    }
  }

}
